<template>
  <div class="controlRange">
    <!-- 搜索区域 -->
    <SiruiSearch
      ref="siruiSearch"
      :query="query"
      :columns="searchColumns"
      @resetBtnClick="resetBtnClick"
      @searchBtnClick="searchBtnClick"
    ></SiruiSearch>

    <!--内容-->
    <div class="department-content">
      <el-row type="flex" :gutter="10">
        <el-col :span="6">
          <el-card shadow="hover" class="box-card">
            <div slot="header" class="clearfix">
              <span>{{ $t('company.title') }}</span>
              <span class="i-icon">
                <template v-for="(item, i) in menuButtonList">
                  <i
                    :key="i"
                    v-if="item.type == '0'"
                    :class="item.attributes.buttonStyle"
                    :title="item.label"
                    :hasPermi="item.attributes.authCode"
                    @click="chooseClick(item.attributes.buttonUrl, item)"
                  ></i>
                </template>
              </span>
            </div>
            <el-tree
              :data="data"
              :props="defaultProps"
              :default-expand-all="false"
              highlight-current
              :expand-on-click-node="false"
              @node-click="handleNodeClick"
              ref="tree"
              v-bind:style="{ height: heightTree, 'overflow-y': 'auto' }"
            >
              <span class="custom-tree-node" slot-scope="{ node, data }">
                <span
                  :style="{ color: data.attributes.currentStatus == '1' ? '#ccc' : '#606266' }"
                  >{{ node.label }}</span
                >
              </span>
            </el-tree>
          </el-card>
        </el-col>
        <el-col :span="18">
          <div>
            <el-tabs type="card" v-model="activeName" class="common-tab">
              <el-tab-pane :label="firstLabel" name="first">
                <!--部门组和部门详情-->
                <div class="detail" v-if="!edit">
                  <departmentDetail
                    v-if="detail.type == 'department'"
                    flag="intersetGroup"
                    :detail="detail"
                    :tableData="tableData"
                    :unitData="unitData"
                    ref="departmentDetail"
                  ></departmentDetail>
                  <interestGroupDetail
                    v-else
                    :receiptClaimModeList="receiptClaimModeList"
                    :detail="detail"
                    :tableData="tableData"
                    ref="interestGroupDetail"
                  ></interestGroupDetail>
                </div>
                <!--部门组和部门修改-->
                <div class="detail" v-else>
                  <editIntersetGroup
                    :companyList="companyList"
                    :departmentList="departmentList"
                    @getdepartmentList="getdepartmentList"
                    @getData="getData"
                    @setLoading="setLoading"
                    ref="editIntersetGroup"
                  ></editIntersetGroup>
                </div>
                <!--底部操作按钮-->
                <div class="footer" v-if="edit">
                  <el-button :loading="load" @click="updateSure()" type="primary">{{
                    $t('dialog.confirm')
                  }}</el-button>
                  <el-button @click="edit = false">{{ $t('dialog.cancel') }}</el-button>
                </div>
              </el-tab-pane>
            </el-tabs>
          </div>
        </el-col>
      </el-row>
    </div>
    <add-interest-group
      v-on:getData="getData"
      :companyList="companyList"
      :departmentList="departmentList"
      @getdepartmentList="getdepartmentList"
      ref="addIG"
    ></add-interest-group>
  </div>
</template>
<script>
  import { mapState } from 'vuex';
  import BASE_API from '@/api/dataBase';
  // import API from '@/api/masterData/company.js';
  import GROUP_API from '@/api/masterData/intersetGroup.js';
  import SiruiSearch from '@/components/SiruiSearch';
  import departmentDetail from '../components/detail/departmentDetail';
  import interestGroupDetail from '../components/detail/intersetGroupDetail';
  import AddInterestGroup from '../components/addModal/addInterestGroup';
  import editIntersetGroup from '../components/edit/editIntersetGroup';
  import DataBaseAPI from '@/api/dataBase';
  import XEUtils from 'xe-utils';
  export default {
    name: 'interestGroup',
    components: {
      SiruiSearch,
      departmentDetail,
      interestGroupDetail,
      editIntersetGroup,
      AddInterestGroup,
    },
    data() {
      return {
        activeName: 'first',
        query: {
          interestGroupNameLike: null,
          interestDepartmentCodes: null,
        },
        data: [],
        defaultProps: {
          children: 'children',
          label: function (data) {
            return data.pid || data.label;
          },
        },
        detail: {},
        menuButtonList: [],
        tableData: [],
        unitData: [],
        edit: false,
        load: false,
        companyList: [],
        departmentList: [],
      };
    },
    computed: {
      firstLabel: {
        get: function () {
          if ('department' == this.detail.type) {
            return this.$t('company.departmentInfo');
          } else {
            return '部门组信息';
          }
        },
      },
      //搜索字段
      searchColumns() {
        return [
          {
            prop: 'interestGroupNameLike',
            name: '部门组名称',
            type: 'input',
            placeholder: '请输入部门组名称',
          },
          {
            prop: 'interestDepartmentCodes',
            name: '部门',
            type: 'treeSelect',
            placeholder: '请选择部门',
            // type: 'treeSelect',
            apiUrl: BASE_API.LIST_COMPANY_DEPT_TREE,
            apiData: {
              tenantCode: this.userInfo.tenantCode,
              adminFlag: this.userInfo.adminFlag,
              selfCompanyDepartmentTreeFlag: true,
            },
            span: 12,
            multiple: true,
          },
        ];
      },
      heightTree() {
        return window.innerHeight - 235 + 'px';
      },
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
        receiptClaimModeList() {
          return this.$baseRequest.getDictListByType('receiveClaimPattern');
        },
      }),
    },
    mounted() {
      this.$nextTick(() => {
        this.getButtonList();
        this.getData();
        this.getCompany();
      });
    },
    methods: {
      //获取菜单按钮
      getButtonList() {
        this.getButtons().then((e) => {
          this.menuButtonList = e;
        });
      },
      getData() {
        this.detail = {};
        this.edit = false;
        this.load = false;
        this.tableData = [];
        this.unitData = [];
        const query = this.$refs.siruiSearch.query;
        query.tenantCode = this.userInfo.tenantCode;
        query.adminFlag = this.userInfo.adminFlag;
        this.$axios.post(GROUP_API.INTERSET_GROUP_LIST_TREE, query).then((res) => {
          if (0 == res.data.code) {
            this.data = res.data.data;
          } else {
            this.$alert(res.data.msg);
          }
        });
      },
      //获取公司信息
      async getCompany() {
        let params = {
          id: this.userInfo.userCode,
          userCode: this.userInfo.userCode,
          personName: this.userInfo.userName,
        };
        const selectStatus = await this.$axios.post(DataBaseAPI.GET_PERSON_API, params);
        if (selectStatus.data.code == 0) {
          let personCompanyInfo = selectStatus.data.data.personCompanyInfo || [];
          if (personCompanyInfo[0]) {
            this.companyList = personCompanyInfo.map((it) => {
              return { value: it.personCompanyCode, label: it.personCompanyName };
            });
          }
        }
      },
      // 获取部门
      async getdepartmentList(companyCode) {
        // TODO 公司代码字段未定
        this.departmentList = [];
        let params = {
          id: this.userInfo.userCode,
          userCode: this.userInfo.userCode,
          personName: this.userInfo.userName,
          personCompanyCode: companyCode,
        };
        const selectStatus = await this.$axios.post(DataBaseAPI.GET_PERSON_API, params);
        if (selectStatus.data.code == 0) {
          let personDepartmentInfo = selectStatus.data.data.personDepartmentInfo || [];
          if (personDepartmentInfo[0]) {
            this.departmentList = personDepartmentInfo.map((it) => {
              return { value: it.personDepartmentCode, label: it.personDepartmentName };
            });
          }
        }
      },
      //搜索
      searchBtnClick() {
        this.getData();
      },
      //重置
      resetBtnClick() {
        this.getData();
      },
      chooseClick(type) {
        if (type == 'add') {
          this.addIG();
        } else if (type == 'edit') {
          this.editIG();
        } else if (type == 'delete') {
          this.deleteIG();
        } else {
          this.$message({
            showClose: true,
            message: this.$t('error.clickError'),
            type: 'error',
          });
        }
      },
      //新增部门组
      addIG() {
        this.$refs.addIG.openDialog(true);
      },
      //编辑部门组
      editIG() {
        if (JSON.stringify(this.detail) == '{}') {
          this.$message({
            showClose: true,
            message: this.$t('company.editNoTips'),
            type: 'error',
          });
          return;
        }
        this.edit = true;
        let groupInfo = XEUtils.clone(this.detail, true);
        if (this.detail.type == 'department') {
          // 如果当前选中的是部门，则取他的父级编辑
          groupInfo = this.data.find(
            (item) => item.id == this.detail.interestGroupCode
          )?.attributes;
        }
        this.$nextTick(() => {
          this.$refs.editIntersetGroup.initData(groupInfo);
        });
      },
      //删除部门组
      deleteIG() {
        if (JSON.stringify(this.detail) == '{}') {
          this.$message({
            showClose: true,
            message: '请选中一条记录删除',
            type: 'error',
          });
          return;
        }
        console.log(this.detail.type);
        console.log(
          this.detail.type == 'department'
            ? this.detail.interestDepartmentName
            : this.detail.interestGroupName
        );
        let deleName =
          this.detail.type == 'department'
            ? this.detail.interestDepartmentName
            : this.detail.interestGroupName;
        this.$confirmAction('删除', '确认删除' + deleName + '?')
          .then(() => {
            // if (this.detail.type == 'department') {
            // }
            let api =
              this.detail.type == 'department' ? GROUP_API.DELETE_INOUT : GROUP_API.DELETE_GROUP;
            this.loading.startLoading();
            this.$axios.get(api + this.detail.id).then((res) => {
              this.loading.endLoading();
              if (0 == res.data.code) {
                this.getData();
                this.$message({
                  showClose: true,
                  message: res.data.msg || this.$t('message.success'),
                  type: 'success',
                });
              } else {
                this.$alert(res.data.msg);
              }
            });
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: this.$t('confirm.deleteCancelled'),
            });
          });
      },
      //选择部门组或部门
      handleNodeClick(data) {
        //部门/部门组详情
        this.detail = data.attributes;
        this.detail.type = data.type;
        let params = { interestGroupCode: data.id };
        if (data.type == 'department')
          params = { interestDepartmentCode: this.detail.interestDepartmentCode };
        //所属部门组
        this.$axios.post(GROUP_API.INTERSET_INOUT_LIST, params).then((res) => {
          if (0 == res.data.code) {
            this.tableData = res.data.data;
          } else {
            this.$alert(res.data.msg);
          }
        });
        this.edit = false;
      },
      setLoading(obj) {
        this.load = obj.loading;
        if (obj.edit) {
          this.edit = obj.edit;
        }
      },
      //修改保存
      updateSure() {
        this.$refs.editIntersetGroup.addSure(this.load);
      },
    },
  };
</script>
<style lang="scss" scoped>
  .department-content {
    margin-top: 10px;
  }
  .i-icon {
    float: right;
    i {
      cursor: pointer;
      margin: 0 2px;
    }
  }
  .footer {
    background: #fff;
    height: 60px;
    line-height: 60px;
    margin-top: 10px;
    text-align: center;
  }
</style>
